
import { openDB } from 'idb';

import { InterestCalculation } from '../models/interest';

const dbPromise = openDB('interest-db', 1, {
  upgrade(db) {
    db.createObjectStore('interestCalculations', { keyPath: 'id', autoIncrement: true });
  },
});


export const saveInterestCalculation = async (calculation: InterestCalculation): Promise<void> => {
  const db = await dbPromise;
  await db.add('interestCalculations', calculation);
};

export const fetchInterestCalculations = async (): Promise<InterestCalculation[]> => {
  const db = await dbPromise;
  return await db.getAll('interestCalculations');
};

export const updateInterestCalculation = async (id: number, updatedData: Omit<InterestCalculation, 'id'>): Promise<void> => {
  const db = await dbPromise;
  console.log("Updating record with ID:", id, "with data:", updatedData);
  try {
    await db.put('interestCalculations', { id, ...updatedData });
    console.log("Record updated successfully.");
  } catch (error) {
    console.error("Error updating the record:", error);
    throw error; 
  }
};


export const deleteInterestCalculation = async (id: number): Promise<void> => {
  const db = await dbPromise;
  await db.delete('interestCalculations', id);
};
